module.exports = __webpack_public_path__ + "img/secondary-off.4a18c7a8.svg";